export const getClassNameByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'warning';
  } else if (status === false) {
    return 'success';
  } else {
    return 'danger';
  }
}

export const categorizeItemsByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'Pending';
  } else if (status === false) {
    return 'Whitelisted';
  } else {
    return 'Blacklisted';
  }
}